import { useState } from 'react'
import PropTypes from 'prop-types'
import clip from 'text-clipper'
import { themeV5 } from 'theme/v5'

const TextClip = ({ text, numberOfCharacters }) => {
  const [seeMore, setSeeMore] = useState(false)

  const showSeeMore = text && text.length > numberOfCharacters

  /* eslint-disable */
  return (
    <span
      sx={{
        position: 'relative',
        width: 'inherit',
        paddingRight: 2,
        display: 'inline-block',
      }}
    >
      {text ? 
        <>
          <span
            sx={{
              textAlign: 'justify'
            }}
          >{seeMore ? text : clip(text, numberOfCharacters)}</span>
          <br />
          {showSeeMore && <a
            sx={{
              color: themeV5.palette.text.link,
              textDecoration: 'none',
            }}
            href="#"
            onClick={() => setSeeMore(!seeMore)}
            >
            {seeMore ? 'Show less' : 'Show More'}
          </a>}
        </>
        : '-'}
    </span>
  )
}
/* eslint-enable */

TextClip.propTypes = {
  text: PropTypes.string,
  numberOfCharacters: PropTypes.number.isRequired,
}

export default TextClip
